import api from "./server";
export default {

  
  /**
   * 获取验证码
   * @param {*} p 
   * @returns 
   */
  async sendCode(p) {
    return await api.post("user/sendcode", p);
  },


  /**
   * 登录
   * @param {*} p 
   * @returns 
   */
  async maiboxLogin(p) {
    return await api.post("user/maiboxlogin", p);
  },

  /**
   * 获取平台列表
   * @param {*} p 
   * @returns 
   */
  async queryPlatform(p) {
    return await api.get("other/queryplatform", p);
  },

   /**
   * 获取平台秘钥
   * @param {*} p 
   * @returns 
   */
  async queryAuths(p) {
    return await api.get("user/queryauths", p);
  },


  /**
   * 获取平台秘钥
   * @param {*} p 
   * @returns 
   */
  async addAuths(p) {
    return await api.post("user/addauths", p);
  },

   /**
   * 修改平台秘钥
   * @param {*} p 
   * @returns 
   */
  async updaAuths(p) {
    return await api.post("user/updaauths", p);
  },

   /**
   * 获取回撤任务列表
   * @param {*} p 
   * @returns 
   */
  async queryTask(p) {
    return await api.get("drawdown/querytask", p);
  },

   /**
   * 获取平台列表
   * @param {*} p 
   * @returns 
   */
  async queryPlatform(p) {
    return await api.get("other/queryplatform", p);
  },

     /**
   * 获取策略列表
   * @param {*} p 
   * @returns 
   */
  async queryStrategy(p) {
    return await api.get("other/querystrategy", p);
  },


   /**
   * 添加回撤任务
   * @param {*} p 
   * @returns 
   */
  async addTask(p) {
    return await api.post("drawdown/addtask", p);
  },

     /**
   * 查看任务进度
   * @param {*} p 
   * @returns 
   */
  async queryTaskinfoy(p) {
    return await api.get("drawdown/taskinfo", p);
  },


  /**
   * 查询创建的策略任务列表
   * @param {*} p 
   * @returns 
   */
  async queryStrlist(p) {
    return await api.get("strategy/strlist", p);
  },



   /**
   * 添加涨幅偏离值任务
   * @param {*} p 
   * @returns 
   */
  async addhigh(p) {
    return await api.post("strategy/addhigh", p);
  },
  
  
   /**
   * 修改涨幅偏离值任务
   * @param {*} p 
   * @returns 
   */
  async updahigh(p) {
    return await api.post("strategy/updahigh", p);
  },


   /**
   * 查询订单记录
   * @param {*} p 
   * @returns 
   */
  async OrderRecord(p) {
    return await api.get("tran/orderrecord", p);
  },


   /**
   * 开启策略任务
   * @param {*} p 
   * @returns 
   */
  async open(p) {
    return await api.post("strategy/open", p);
  },

   /**
   * 关闭策略任务
   * @param {*} p 
   * @returns 
   */
  async close(p) {
    return await api.post("strategy/close", p);
  },


    /**
   * 获取通知事件列表
   * @param {*} p 
   * @returns 
   */
  async NoticeEvent(p) {
    return await api.get("other/noticeevent", p);
  },


    /**
   * 获取用户订阅通知列表
   * @param {*} p 
   * @returns 
   */
  async UserEvent(p) {
    return await api.get("user/userevent", p);
  },
  
   /**
   * 修改用户订阅
   * @param {*} p 
   * @returns 
   */
  async UpdaEvent(p) {
    return await api.post("user/updaevent", p);
  },



    /**
   * 获取high 运行数据
   * @param {*} p 
   * @returns 
   */
  async HighData(p) {
    return await api.get("data/highdata", p);
  },


    /**
   * 获取交易订单信息（交易平台的
   * @param {*} p 
   * @returns 
   */
  async OrderInfo(p) {
    return await api.get("tran/orderinfo", p);
  },

  
    /**
   * 获取指定symbol现价格
   * @param {*} p 
   * @returns 
   */
  async Contract_Price(p) {
    return await api.get("tran/contract", p);
  },


    /**
   * 提交平仓
   * @param {*} p 
   * @returns 
   */
  async ClosePosition(p) {
    return await api.post("tran/closeposition", p);
  },

   
    /**
   * 获取账户资金
   * @param {*} p 
   * @returns 
   */
  async AssetsDetail(p) {
    return await api.get("user/assetsdetail", p);
  },



  

  


    

    
  

}







